export enum MarketType
{
    Student = 'Student',
    SingleFamily = 'SingleFamily',
    MultiFamily = 'MultiFamily'
}